export const CACHE_KEY = 'dashboard_stats_cache';
export const CACHE_EXPIRY_MS = 60000; // 1 minute in milliseconds
